var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlayVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 34 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m.896.22 32.727 16.324L.896 32.948V.221Z",
  fill: "currentColor"
})));
export default SvgPlayVideo;